module.exports = __webpack_public_path__ + "img/Rectangle 1335.aa80bc4.png";